import api from '@/api'
import router from '@/router'
import { defineStore } from 'pinia'

interface OrganizationInfo {
  name?: string
}

export interface ContractInfo {
  uuid?: string
  signed_doc_hash?: string
  unsigned_doc_hash?: string
  client_phone?: string
  code_sended?: boolean
  link_sended?: boolean
  organization?: OrganizationInfo
  name?: string
}

interface DataStoreState {
  contractInfo: ContractInfo
  loaded: boolean
}

export const useDataStore = defineStore('dataStore', {
  state: (): DataStoreState => ({
    contractInfo: {},
    loaded: false
  }),
  actions: {
    async loadData(uuid: string) {
      if (this.loaded) return

      try {
        const [contractInfoRes] = await Promise.all([api.get('/info/' + uuid)])
        if (contractInfoRes.status === 502) {
          window.location.reload()
        }

        this.contractInfo = (contractInfoRes.data || {}) as ContractInfo
        this.loaded = true
      } catch (err: unknown) {
        const error = err as { response?: { status?: number } }

        if (error.response && error.response.status === 401) {
          // Handled upstream by auth middleware/interceptors.
        } else if (error.response && error.response.status === 404) {
          router.push('/404')
          this.contractInfo = {}
        } else {
          location.reload()
        }

        console.error('Ошибка при загрузке данных', err)
      }
    }
  }
})
